import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme) => ({
  dialogContainer: {},
  contentWrap: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
  },
  centerContent: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  content: {
    minHeight: 800,
    // minWidth: 800
  },
  title: {
    textAlign: 'center',
    fontSize: 16,
  },
  close: {
    fontSize: 15,
    color: theme.palette.text.primary,
    position: 'absolute',
    top: theme.spacing(1),
    left: theme.spacing(2),
  },
  container: {
    padding: (p) => (p.isMobile ? 0 : theme.spacing(4)),
    zIndex: `1000 !important`,
  },
  dialogContent: {
    // overflowY: 'none',
  },

  searchRow: {
    '& .MuiFormControl-root': {
      marginRight: theme.spacing(1),
      minWidth: 150,

      '&:nth-child(1)': {
        minWidth: 300,
      },
    },
  },

  cloneBtn: {
    marginTop: theme.spacing(4),
  },

  tableContainer: {
    marginTop: theme.spacing(4),
    position: 'relative',
  },
  tableHeader: {
    borderBottom: `1px solid ${theme.palette.action.disabled}`,
    fontWeight: 'bold',
    fontSize: 14,
    backgroundColor: theme.palette.action.disabledBackground,
  },
  tableContent: {},
  tableRow: {
    display: 'flex',
    position: 'relative',
    flexDirection: (p) => (p.isMobile ? 'column' : 'row'),
    paddingLeft: (p) => (p.isMobile ? theme.spacing(5) : 0),
    justifyContent: 'center',
    marginBottom: (p) => (p.isMobile ? theme.spacing(2) : 0),

    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      cursor: 'pointer',
    },
  },
  col: {
    position: 'relative',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    overflow: 'hidden',

    '&.checkbox': {
      position: 'absolute',
      left: 0,
      height: '100%',
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex',
    },

    '& .IMAGE': {
      margin: 2,
      marginBottom: 2,
    },
  },
  colText: {
    fontSize: 13,
  },
  col_0: {
    width: theme.spacing(5),
  },
  col_1: {
    width: (p) => (p.isMobile ? '100%' : '15%'),
    marginLeft: theme.spacing(5),
  },
  col_2: {
    width: (p) => (p.isMobile ? '100%' : '10%'),
  },
  col_3: {
    width: (p) => (p.isMobile ? '100%' : '10%'),
  },
  col_4: {
    width: (p) => (p.isMobile ? '100%' : '10%'),
  },
  col_5: {
    width: (p) => (p.isMobile ? '100%' : '25%'),
  },
  col_6: {
    width: (p) => (p.isMobile ? '100%' : '25%'),
  },
}));
